angular.module('core')
  .directive('helpTooltip', function() {
    return {
      restrict: 'E',
      scope: {
      },
      templateUrl: '/resources/core/partials/help-tooltip.html',
      controller: 'HelpTooltipController'
    };
  });

angular.module('core').controller('HelpTooltipController', ['$scope', '$element', '$filter', '$rootScope', '$cookies', function($scope, $element, $filter, $rootScope, $cookies) {
  $scope.shift = false;
  $scope.open = false;
  $scope.positionStyling = {
    'left':'0px',
    'top' :'0px'
  };

  $scope.disableTooltips = function() {
    $scope.closeTooltip();
    $rootScope.helpEnabled = false;
    $cookies.put('helpEnabled', String(false));
  };

  $scope.closeTooltip = function() {
    if($scope.open === true) {
      $scope.open = false;
    }
  };

  $rootScope.$on('$stateChangeSuccess', function(e) {
    $scope.closeTooltip();
  });

  $scope.toggleHotspot = function() {
    $scope.open = !$scope.open;
  };

  $scope.positionTooltip = function(xPos, yPos) {
    if ($scope.shift === true) {
      $scope.positionStyling.left = (xPos - 381) + 'px';
    }
    else {
      $scope.positionStyling.left = (xPos - 11) + 'px';
    }
    $scope.positionStyling.top = (yPos + 60) + 'px';
  };

  var setupHelpTooltip = function(e, ast, title, message, xPos, yPos, shift) {
    if (shift === "left") {
      $scope.shift = true;
    }
    else {
      $scope.shift = false;
    }
    if ($scope.open === true) {
      $scope.closeTooltip();
    }
    var domainTextFilter = $filter('domainText');
    $scope.title = domainTextFilter(title, ast);
    $scope.message = domainTextFilter(message, ast);
    $scope.positionTooltip(xPos, yPos);
    $scope.toggleHotspot();
  };

  $scope.$on('hotspotClicked', setupHelpTooltip);
}]);
